import { KrCard } from '@/common/card/KrCard';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { EntityAuditCard } from '@/common/form/cards/EntityAuditCard';
import { EntitySectionCard } from '@/common/form/cards/EntitySectionCard';
import { EntityStatusCard } from '@/common/form/cards/EntityStatusCard';
import { ScrollableSpacerLayoutArea } from '@/common/layout/ScrollableSpacerLayoutArea';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from 'react';
import { ConfigList } from './ConfigList';

export const ConfigForm = ({ entityId, parentOrgId, augFieldDefs, children }) => {
  const [alignment, setAlignment] = useState('uploadedVersions');

  const augConfigFieldDefs = (fieldToFieldDef) => {
    if (augFieldDefs) {
      augFieldDefs(fieldToFieldDef);
    }
  };

  const handleChange = (_event, nextAlignment) => {
    if (nextAlignment == null) return;
    setAlignment(nextAlignment);
  };

  const historyButtons = (
    <ToggleButtonGroup
      color="primary"
      value={alignment}
      exclusive
      size="small"
      onChange={handleChange}
      sx={{ width: 'fit-content' }}
    >
      <ToggleButton value="uploadedVersions">Uploaded Versions</ToggleButton>
      <ToggleButton value="fullHistory">Full History</ToggleButton>
    </ToggleButtonGroup>
  );

  return (
    <EntityForm entity="CONFIG" entityId={entityId} augFieldDefs={augConfigFieldDefs}>
      {children ?? (
        <SpacerLayout>
          <Spacer weights={[3, 1]}>
            <ScrollableSpacerLayoutArea>
              <EntitySectionCard title="General" />
              <KrCard title="History" variant="soft" fill minHeight={200} buttons={historyButtons}>
                <ConfigList
                  parentConfigId={entityId}
                  parentOrgId={parentOrgId}
                  fullHistory={alignment === 'fullHistory'}
                />
              </KrCard>
            </ScrollableSpacerLayoutArea>
            <ScrollableSpacerLayoutArea>
              <EntityStatusCard />
              <EntityAuditCard />
            </ScrollableSpacerLayoutArea>
          </Spacer>
        </SpacerLayout>
      )}
    </EntityForm>
  );
};
